import { HistoryDto, IdentityDto } from './../../shared';
import { ClusterConfigDto } from './cluster-config.dto';
import { ClusterEntityDto } from './entitie.dto';

export class ClusterDto {
  clusterConfig: ClusterConfigDto;
  entities: ClusterEntityDto[];
  history: HistoryDto;
  identity: IdentityDto;
  methodKey: string;
  size: number;

  constructor(d?: ClusterDto) {
    if (!d) {
      return;
    }

    Object.assign(this, d);

    if (d.clusterConfig) {
      this.clusterConfig = new ClusterConfigDto(d.clusterConfig);
    }

    if (d.entities.length) {
      this.entities = d.entities.map(i => new ClusterEntityDto(i));
    }

    if (d.history) {
      this.history = new HistoryDto(d.history);
    }

    if (d.identity) {
      this.identity = new IdentityDto(d.identity);
    }
  }
}
